import type { ProductionRun } from "./models";

/** The regular poll and counter-triggered refresh share one scoped read.
 * Confirmed writes invalidate that flight so a new read cannot reuse a
 * snapshot that was requested before the write. Response ownership remains
 * with the workspace, including requests which finish after invalidation. */
export class ProductionRunsReadCoordinator {
  private readonly pending = new Map<string, Promise<ProductionRun[]>>();

  read(scope: string, read: () => Promise<ProductionRun[]>): Promise<ProductionRun[]> {
    const current = this.pending.get(scope);
    if (current) return current;
    const request = Promise.resolve().then(read).finally(() => {
      if (this.pending.get(scope) === request) this.pending.delete(scope);
    });
    this.pending.set(scope, request);
    return request;
  }

  hasPending(scope: string) {
    return this.pending.has(scope);
  }

  invalidate(scope: string) {
    this.pending.delete(scope);
  }
}
